import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageShell } from '../components/Layout';
import { IconArrowLeft, IconX } from '../components/Icons';

export default function PaymentFailurePage() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageShell>
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <div className="bg-white border-2 border-clay shadow-stamp p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-6 bg-clay/10 border-2 border-clay flex items-center justify-center text-clay">
            <IconX className="w-8 h-8" />
          </div>
          <h1 className="font-serif text-3xl text-forest font-semibold">Payment not completed</h1>
          <p className="text-sm text-ink/60 mt-3">No amount was charged. You can try again from your search results.</p>
          <div className="mt-8 space-y-3">
            <button type="button" onClick={() => navigate(-2)} className="btn-primary w-full">
              <IconArrowLeft className="w-5 h-5" />
              Back to results
            </button>
            <button type="button" onClick={() => navigate('/')} className="btn-outline w-full">
              Home
            </button>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
